/** @format */

import React from "react";
import {
  Row,
  Col,
  Card,
  CardHeader,
  CardTitle,
  CardBody,
  FormGroup,
  Label,
  Input,
  Button,
} from "reactstrap";

export default function PrintOptionSettings({ settings, onSettingsChange }) {
  const handleReceiptTemplateChange = (e) => {
    const { name, type, checked, value } = e.target;
    onSettingsChange({
      ...settings,
      receiptTemplate: {
        ...settings.receiptTemplate,
        [name]: type === "checkbox" ? checked : value,
      },
    });
  };

  const handleOptionChange = (e) => {
    const { name, value } = e.target;
    onSettingsChange({
      ...settings,
      [name]: value,
    });
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle tag="h5">Printer Settings</CardTitle>
      </CardHeader>
      <CardBody>
        {/* Receipt Template Settings */}
        <Row>
          <Col md={4}>
            <FormGroup check>
              <Label check>
                <Input
                  type="checkbox"
                  name="showStoreName"
                  checked={settings.receiptTemplate?.showStoreName || false}
                  onChange={handleReceiptTemplateChange}
                />
                Show Store Name
              </Label>
            </FormGroup>
          </Col>
          <Col md={4}>
            <FormGroup check>
              <Label check>
                <Input
                  type="checkbox"
                  name="showStoreAddress"
                  checked={settings.receiptTemplate?.showStoreAddress || false}
                  onChange={handleReceiptTemplateChange}
                />
                Show Store Address
              </Label>
            </FormGroup>
          </Col>
          <Col md={4}>
            <FormGroup check>
              <Label check>
                <Input
                  type="checkbox"
                  name="showStorePhone"
                  checked={settings.receiptTemplate?.showStorePhone || false}
                  onChange={handleReceiptTemplateChange}
                />
                Show Phone Number
              </Label>
            </FormGroup>
          </Col>
        </Row>

        <Row className="mt-2">
          <Col md={4}>
            <FormGroup check>
              <Label check>
                <Input
                  type="checkbox"
                  name="showStoreEmail"
                  checked={settings.receiptTemplate?.showStoreEmail || false}
                  onChange={handleReceiptTemplateChange}
                />
                Show Email
              </Label>
            </FormGroup>
          </Col>
          <Col md={4}>
            <FormGroup check>
              <Label check>
                <Input
                  type="checkbox"
                  name="showStoreLogo"
                  checked={settings.receiptTemplate?.showStoreLogo || false}
                  onChange={handleReceiptTemplateChange}
                />
                Show Logo
              </Label>
            </FormGroup>
          </Col>
        </Row>

        <Row className="mt-3">
          <Col md={12}>
            <FormGroup row>
              <Label sm={3}>Header Note</Label>
              <Col sm={9}>
                <Input
                  type="text"
                  name="headerNote"
                  placeholder="e.g., Have a nice day"
                  value={settings.receiptTemplate?.headerNote || ""}
                  onChange={handleReceiptTemplateChange}
                />
              </Col>
            </FormGroup>
          </Col>
          <Col md={12}>
            <FormGroup row>
              <Label sm={3}>Footer Note</Label>
              <Col sm={9}>
                <Input
                  type="text"
                  name="footerNote"
                  placeholder="e.g., Thank you for your visit"
                  value={settings.receiptTemplate?.footerNote || ""}
                  onChange={handleReceiptTemplateChange}
                />
              </Col>
            </FormGroup>
          </Col>
        </Row>

        {/* Receipt Print Options */}
        <Row className="align-items-center mb-2 mt-2">
          <Col md={12}>
            <FormGroup row>
              <Label sm={3}>Receipt Print</Label>
              <Col md={9}>
                <FormGroup check className="d-flex gap-4 mt-2">
                  {["always", "prompt", "never", "default"].map((opt) => (
                    <Label key={opt} check className="form-check-inline">
                      <Input
                        type="radio"
                        name="receipt_print_option"
                        value={opt}
                        checked={settings.receipt_print_option === opt}
                        onChange={handleOptionChange}
                      />
                      {opt.charAt(0).toUpperCase() + opt.slice(1)} Print
                    </Label>
                  ))}
                </FormGroup>
              </Col>
            </FormGroup>
          </Col>
        </Row>

        {/* Label Print Options */}
        <Row className="align-items-center mb-3">
          <Col md={12}>
            <FormGroup row>
              <Label sm={3}>Label Print</Label>
              <Col md={9}>
                <FormGroup check className="d-flex gap-4 mt-2">
                  {["always", "prompt", "never", "default"].map((opt) => (
                    <Label key={opt} check className="form-check-inline">
                      <Input
                        type="radio"
                        name="label_print_option"
                        value={opt}
                        checked={settings.label_print_option === opt}
                        onChange={handleOptionChange}
                      />
                      {opt.charAt(0).toUpperCase() + opt.slice(1)} Print
                    </Label>
                  ))}
                </FormGroup>
              </Col>
            </FormGroup>
          </Col>
        </Row>

        {/* Label Print Options */}
        {/* <Row className="align-items-center mb-3">
          <Col md={12}>
            <FormGroup row>
              <Label sm={3}>Report Print</Label>
              <Col md={9}>
                <FormGroup check className="d-flex gap-4 mt-2">
                  {["always", "prompt", "never", "default"].map((opt) => (
                    <Label key={opt} check className="form-check-inline">
                      <Input
                        type="radio"
                        name="report_print_option"
                        value={opt}
                        checked={settings.report_print_option === opt}
                        onChange={handleOptionChange}
                      />
                      {opt.charAt(0).toUpperCase() + opt.slice(1)} Print
                    </Label>
                  ))}
                </FormGroup>
              </Col>
            </FormGroup>
          </Col>
        </Row> */}
      </CardBody>
    </Card>
  );
}
